import { trackEvent } from "tracker/tracker"

const { ZIPLOGIX_HOW_TO_LINK_URL } = require("../../env")

export const LOGIN_POPUP_ERROR = {
  OAUTH_ERROR: "OAUTH_ERROR",
  GENERIC_ERROR: "ERROR",
  UNKNOWN_ERROR: "UNKNOWN_ERROR"
}

export const openZiplogixHowToLinkPage = () => () => {
  trackEvent("clickOnHowToLink", {
    partner: "ziplogix"
  })
  window.open(ZIPLOGIX_HOW_TO_LINK_URL, "")
}

export const ACCOUNT_LINKING_ZIPLOGIX = {
  id: "ziplogix",
  provider: "ziplogix",
  imgHeight: "40px",
  btnDetailOnUnlink: "How to link",
  btnDetailOnLinked: "Unlink",
  showBy: "partnerId",
  padding: "0px",
  showLinkWithMessage: false,
  canUnlink: true,
  handleOnClick: openZiplogixHowToLinkPage,
  unlinkTitle: "Unlinking with zipForm®️ Plus will cancel some benefits:",
  unlinkCancelButtonText: "Reconsider",
  unlinkConfirmButtonText: "Confirm"
}

export const ACCOUNT_LINKING_CAR = {
  id: "car-nrds",
  provider: "car",
  btnDetailOnUnlink: "Link",
  btnDetailOnLinked: "Unlink",
  canUnlink: true,
  unlinkTitle: "Unlinking with CAR will cancel some benefits",
  unlinkCancelButtonText: "Cancel",
  unlinkConfirmButtonText: "Unlink",
  showLinkWithMessage: false,
  showBy: null,
  modalId: "CAR",
  modalTitle: "Validate CAR membership",
  modalDescription: `This one-time process will grant you access to all
  features available for CAR members such as CAR form`
}

export const ACCOUNT_LINKING_TAR = {
  id: "tar",
  provider: "tar",
  btnDetailOnUnlink: "Link",
  btnDetailOnLinked: "Unlink",
  canUnlink: true,
  unlinkTitle: "Unlinking with TR® will cancel some benefits",
  unlinkCancelButtonText: "Cancel",
  unlinkConfirmButtonText: "Unlink",
  showLinkWithMessage: false,
  showBy: null,
  modalId: "TAR",
  modalTitle: "Validate TR® membership",
  modalDescription: `This one-time process will grant you access to all features available for TR® members such as the TXR rental application form.`
}

export const PARTNER_DISPLAY_NAME = {
  ziplogix: "zipForm®️ Plus",
  car: "CAR",
  tar: "TR®"
}

export const PARTNER_FORM_NAME = {
  car: PARTNER_DISPLAY_NAME.car,
  tar: "TXR"
}

/*
 * Partners whose linked-account brokerage details an agent may edit. The block
 * prints in the partner's e-sign footer; it is display data, never identity.
 */
export const BROKERAGE_EDITABLE_PARTNERS = ["tar"]
export const EDIT_BROKERAGE_BUTTON_TEXT = "Edit brokerage"
export const BROKERAGE_UPDATED_MESSAGE = "Your brokerage details were updated."
export const BROKERAGE_LOAD_ERROR_MESSAGE =
  "We couldn't load your brokerage details. Enter them here, or skip for now and edit them later from the Texas Realtors row."
export const BROKERAGE_UPDATE_ERROR_MESSAGE =
  "We couldn't save your brokerage details. Please try again."

export const UNLINK_MESSAGE_SUCCESSFUL = {
  car: "Your CAR account was successfully unlinked.",
  tar: "Your TR® account was successfully unlinked."
}
export const LINK_MESSAGE_SUCCESSFUL = {
  car: "Your CAR account was successfully linked.",
  tar: "Your TR® account was successfully linked."
}

export const UNLINK_MESSAGE_ERROR = {
  car: "Sorry, we have encountered an error unlinking your CAR account.",
  tar: "Sorry, we have encountered an error unlinking your TR® account."
}

export const CAR_SSO_ALREADY_LINKED_MESSAGE =
  "This C.A.R. membership is already linked to another account"

export const POPUP_BLOCKED_MESSAGE =
  "The verification popup was blocked. Allow popups for this site and try again."

export const ERROR_MESSAGE = {
  NOT_FOUND:
    "We couldn’t find a match for that NRDS ID. Please double-check your entry.",
  MEMBERSHIP_INVALID:
    "We couldn’t verify your membership. Please reach out to your association for help.",
  NRDS_ID_ALREADY_LINKED:
    "This NRDS ID is already connected to another account.",
  GENERAL: partnerName =>
    `Sorry, we have encountered an error linking your ${partnerName} account. Please try again.`
}

export const CAR_POP_UNDER_MODAL = {
  title: "CAR account successfully linked",
  text: "Click continue to proceed (will open in new tab)",
  button: "Continue"
}

export const CAR_EXIT_URL = "https://www.car.org/rentspreeexit"
